// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");

var line = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.border(BrowserStyle.rem(0.03125), "solid", {
            TAG: /* Grey */2,
            _0: /* Light */3
          }),
      tl: {
        hd: BrowserStyle.flexGrow(1.0),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.px(0)),
          tl: {
            hd: BrowserStyle.margin(BrowserStyle.zero),
            tl: /* [] */0
          }
        }
      }
    });

var Styles = {
  line: line
};

function BrowserComponents_HR$Light(Props) {
  var className = Props.className;
  return React.createElement("hr", {
              className: BrowserStyle.Utils.extendBaseStyle(line, className)
            });
}

var Light = {
  Styles: Styles,
  make: BrowserComponents_HR$Light
};

var line$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderColor({
            TAG: /* Grey */2,
            _0: /* Dark */1
          }),
      tl: /* [] */0
    });

var Styles$1 = {
  line: line$1
};

function BrowserComponents_HR$Dark(Props) {
  var className = Props.className;
  return React.createElement(BrowserComponents_HR$Light, {
              className: BrowserStyle.Utils.extendBaseStyle(line$1, className)
            });
}

var Dark = {
  Styles: Styles$1,
  make: BrowserComponents_HR$Dark
};

var make = BrowserComponents_HR$Light;

exports.Light = Light;
exports.Dark = Dark;
exports.Styles = Styles;
exports.make = make;
/* line Not a pure module */
